module.exports = __webpack_public_path__ + "static/media/Prince-Dolf.662fa92e.png";